module.exports = __webpack_public_path__ + "img/img_2.a9912465.png";